import { Space, Tag } from 'antd'

export default {
  renderBelong (text: any, record: any, ListTableContext: any) {
    return <Space>{record.Apps.map((item: string) => <Tag key={item}>{item}</Tag>)}</Space>
  },
}